<template>

    <form @submit.prevent="handleSubmit" class="pt-4">
        <div class="col-md-12 mb-4" :class="{ 'invalid' : validationErrors.name}">
            <label class="form-label">Name <span class="text-primary">*</span></label>
            <input
                v-model="contact.name"
                type="text"
                class="form-control mb-0"
                placeholder="John">
            <small v-if="validationErrors.name">{{ validationErrors.name }}</small>
        </div>
        <div class="col-md-12 mb-4" :class="{ 'invalid' : validationErrors.email}">
            <label class="form-label">Email <span class="text-primary">*</span></label>
            <input
                v-model="contact.email"
                type="email"
                class="form-control mb-0"
                placeholder="John">
            <small v-if="validationErrors.email">{{ validationErrors.email }}</small>
        </div>
        <div class="col-md-12 mb-4" :class="{ 'invalid' : validationErrors.phone}">
            <label class="form-label">Phone Number <span class="text-primary">*</span></label>
            <input
                v-model="contact.phone"
                type="text"
                class="form-control mb-0"
                placeholder="123 456 789">
            <small v-if="validationErrors.phone">{{ validationErrors.phone }}</small>
        </div>
        <div class="col-md-12 mb-4" :class="{ 'invalid' : validationErrors.message}">
            <label class="form-label">Message <span class="text-primary">*</span></label>
            <textarea class="form-control mb-0" v-model="contact.message"
            ></textarea>
            <small v-if="validationErrors.phone">{{ validationErrors.message }}</small>
        </div>
        <button
            type="submit"
            class="btn btn-primary w-full"
            :disabled="loading"
        >
            <span v-if="!loading">Send</span><span v-else>Wait...</span>
        </button>
    </form>
</template>

<script>

import {mapActions} from "vuex";

export default {
    name: "ContactForm",
    props: {
        subject: {
            type: String,
            default: 'Contact Form',
        }
    },
    data() {
        return {
            validationErrors: {},
            loading: false,
            contact: {
                name: '',
                email: '',
                phone: '',
                message: ''
            },
            userIsBlock: false,
            showSuccess: false,
            errorMessage: '',
            defaultErrorMessage: 'Something went wrong',
            successMessage: '',
            defaultSuccessMessage: 'Success! You can close this window!'
        }
    },
    methods: {
        ...mapActions('app', ['sendContacts']),
        validate() {
            this.validationErrors = {};

            if (!this.contact.name || !this.contact.name.length) {
                this.validationErrors.name = 'Name is required field';
            }

            if (!this.contact.message || !this.contact.message.length) {
                this.validationErrors.message = 'Message is required field';
            }

            if (!this.contact.email || !this.contact.email.length) {
                this.validationErrors.email = 'Email is required field';
            } else {
                if (!this.contact.email.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    // probably, never happens because of browser internal validation
                    this.validationErrors.email = 'Email value is incorrect';
                }
            }

            if (!this.contact.phone || !this.contact.phone.length) {
                this.validationErrors.phone = 'Phone is required field';
            } else {
                if (!this.contact.phone.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)) {
                    this.validationErrors.phone = 'Phone value is incorrect';
                }
            }

            return Object.keys(this.validationErrors).length === 0;
        },

        async handleSubmit() {
            if (!this.validate()) {
                this.$notify({
                    text: 'ERROR',
                    type: 'error'
                });
                return;
            }


            await this.save()

        },

        async save() {
            this.loading = true;
            this.errorMessage = '';
            const response = await this.sendContacts({...this.contact, subject: this.subject});
            if (!response.data.status) {
                this.$notify({
                    text: response.data.message ? response.data.message : 'Something went wrong. Please, try again.',
                    type: 'error'
                });
            } else {
                this.$notify({
                    text: 'SUCCESS',
                    type: 'success'
                });
                this.contact = {
                    name: '',
                    email: '',
                    phone: '',
                    message: ''
                };
            }
            this.loading = false;
        },
    }
}
</script>

<style scoped>
.invalid, .invalid * {
    color: red !important;
}
</style>
